import Box from '@mui/material/Box'
import ContentLoading from 'components/shared/ContentLoading'
import { memo } from 'react'

import useCellVisualizationUrlParams from '../useCellVisualizationUrlParams'
import ScatterPlot from './ScatterPlot'
import { usePlotData } from './usePlotData'

export const MainGraphContent = memo((): JSX.Element => {
  const { isPreFilter } = useCellVisualizationUrlParams()
  const allPlotData = usePlotData()
  const { scatterPlotMetaData } = allPlotData

  // Data is ready when metadata has cell coordinates
  // Even if all clusters are hidden (plotData empty), gray background cells should show
  const dataIsReady = scatterPlotMetaData.cellIds.length > 0

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        paddingTop: '0.5rem',
      }}
    >
      {dataIsReady ? (
        <ScatterPlot {...allPlotData} isPreFilter={isPreFilter} />
      ) : (
        <ContentLoading />
      )}
    </Box>
  )
})

MainGraphContent.displayName = 'MainGraphContent'

export default MainGraphContent
